export const EXPANDABLE_CONTAINER_TITLE = 'ExpandableContainer-title';
export const EXPANDABLE_CONTAINER = 'ExpandableContainer';
